function AddToCart() {
    //Get all our object scoped elements and params
    this.cartButton = document.querySelectorAll(".cartButton");
    this.quantityContainer =
        document.getElementsByClassName("productQuantity")[0];

    this.init = function () {
        this.handleEvents();
    };

    this.handleEvents = () => {
        //Add to cart button
        this.cartButton.forEach((button) => {
            button.addEventListener("click", () => {
                const variant = button.dataset.variant;
                const quantity = this.quantityContainer.value;

                // get added protection plan ids
                const protectionPlanHiddenInputs = document.querySelectorAll(
                    ".protectionPlanHiddenInput"
                );

                if (protectionPlanHiddenInputs.length > 0) {
                    const protectionPlanIds = [];
                    protectionPlanHiddenInputs.forEach((input) => {
                        if (input.value === "true") {
                            protectionPlanIds.push(input.id.split("_")[1]);
                        }
                    });

                    this.addItemToCart(variant, quantity, protectionPlanIds);
                } else {
                    this.addItemToCart(variant, quantity);
                }
            });
        });

        // Cross sells check boxes
        document
            .querySelectorAll(
                ".cross-sells input[type=checkbox][name^=addToCart_crossSell]"
            )
            .forEach((checkbox) => {
                checkbox.addEventListener("change", (e) => {
                    if (e.target.checked) {
                        this.toggleProductOnCartButton("add", e.target.value);
                        getSVGIcon(
                            "check-square",
                            "",
                            e.target.nextElementSibling,
                            true
                        );
                    } else {
                        this.toggleProductOnCartButton(
                            "remove",
                            e.target.value
                        );
                        getSVGIcon(
                            "square-o",
                            "",
                            e.target.nextElementSibling,
                            true
                        );
                    }
                });
            });
    };

    this.addItemToCart = async (
        variant,
        quantity,
        protectionPlanIds = null
    ) => {
        GoogleAnalytics.onAddToCart(variant, quantity);
        const data = new URLSearchParams({
            variant: variant,
            quantity: quantity,
        });

        // Show loading spinner
        showLoadingOverlay();

        try {
            const response = await fetch(
                globalObject.url + "ajax/ecommerce.php?action=addToCart",
                {
                    method: "POST",
                    body: data,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Network response was not ok");
                hideLoadingOverlay();
            }

            // Get cart quantity
            const quantity = await this.getCartQuantity();

            // Update quantity in cart header
            if (quantity > 0 && document.querySelector(".quantityInCart")) {
                document.querySelector(".quantityInCart").innerHTML =
                    " (" + quantity + ")";
            }

            updateCartQuantity();

            // add protection plans to cart if applicable
            if (protectionPlanIds != null) {
                this.addProtectionPlansToCart(protectionPlanIds, variant);
                protectionPlanIds.forEach((ppid) => {
                    document.querySelector(
                        `#protectionPlanRemove_${ppid}`
                    ).style.display = "none";
                });
            }

            // Show overlay, timeout to allow for cart to update
            setTimeout(() => {
                this.showOverlay(variant);
            }, 500);
            pushToDataLayer("addToCart", variant);
        } catch (error) {
            console.error("Error:", error);
            hideLoadingOverlay();
        }
    };

    this.addProtectionPlansToCart = (protectionPlanIds, variantId=null) => {
        if (protectionPlanIds === null) return;

        protectionPlanIds.forEach((id) => {
            fetch(
                globalObject.url +
                    "ajax/ecommerce.php?action=applyProtectionPlan",
                {
                    method: "POST",
                    body: new URLSearchParams({ plan: id, variant: variantId }),
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            )
                // .then((response) => response.text())
                // .then((response) => console.log(response))
                .catch((error) => console.error("Error:", error));
        });
    };

    this.getCartQuantity = async () => {
        try {
            const response = await fetch(
                globalObject.url + "ajax/ecommerce.php?action=getCartQuantity",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            return response.text();
        } catch (error) {
            console.error("Error:", error);
            return null;
        }
    };

    this.applyProtectionPlanModalClickListeners = () => {
        const modalOverlay = document.querySelector(".addToCartOverlay");
        if (!modalOverlay) return;

        const includeBtns = document.querySelectorAll(
            ".applyProtectionPlanModal"
        );
        if (!includeBtns) return;

        for (let i = 0; i < includeBtns.length; i++) {
            includeBtns[i].addEventListener("click", () => {
                const plan = includeBtns[i].dataset.plan;
                const variant = includeBtns[i].dataset.variant;
                this.addProtectionPlansToCart([plan], variant);
                const icon = document.querySelector(
                    `#protectionPlanIconModal_${plan}`
                );
                // hide button
                includeBtns[i].style.display = "none";
                // show added to cart
                document.querySelector(
                    `#protectionPlanAddedToCart_${plan}`
                ).style.display = "inline-block";
                // update icon
                icon.innerHTML =
                    '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-check"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/><path d="m9 12 2 2 4-4"/></svg>';
            });
        }
    };

    this.showOverlay = function (variant) {
        // Show loading spinner
        showLoadingOverlay();

        fetch(globalObject.url + "ajax/ecommerce.php?action=addToCartOverlay", {
            method: "POST",
            body: new URLSearchParams({ variant: variant }),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        })
            .then((response) => response.text())
            .then((overlay) => {
                //Activate Swiper for related products
                new Swiper(".product-swiper-container", {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    loop: true,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                        },
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                });
                // Add modal to body
                displayModal(overlay);

                // Continue shopping button
                const continueShoppingBtn =
                    document.querySelector(".continueShopping");
                if (continueShoppingBtn) {
                    continueShoppingBtn.addEventListener("click", () => {
                        removeModal();
                    });
                }

                // Protection plan modal click listeners
                this.applyProtectionPlanModalClickListeners();
            })
            .catch((error) => console.error("Error:", error))
            .finally(() => {
                hideLoadingOverlay();
            });
    };

    this.toggleProductOnCartButton = function (action, variant) {
        // Only grab cart button next to large image
        const cartButton = document.querySelector(".productInfo .cartButton");
        if (cartButton) {
            const variants = cartButton.dataset.variant.toString().split(",");
            variant = variant.toString();

            switch (action) {
                case "add":
                    //Add to variants array
                    if (variants.indexOf(variant) === -1) {
                        variants.push(variant);
                    }
                    break;
                case "remove":
                    //Remove from variants array
                    variants.forEach(function (element, i) {
                        if (element == variant) {
                            variants.splice(i, 1);
                        }
                    });
                    break;
            }

            //Set prod data attribute on cart button
            cartButton.dataset.variant = variants.join();

            //Change cart button text
            const icon = cartButton.querySelector(".svg-icon").outerHTML;
            if (variants.length > 1) {
                cartButton.innerHTML =
                    icon + " Add to Cart (" + variants.length + ")";
            } else {
                cartButton.innerHTML = icon + " Add to Cart";
            }
        }
    };
}

function ProductPageQuantity() {
    this.quantityContainer =
        document.getElementsByClassName("productQuantity")[0];
    this.cartButton = document.getElementsByClassName("cartButton")[0];

    this.init = function () {
        if (!this.quantityContainer) return;
        this.handleEvents();
    };

    this.handleEvents = function () {
        this.quantityContainer.addEventListener("change", () => {
            const variant = this.cartButton.dataset.variant;
            const quantity = this.quantityContainer.value;

            this.updateDeliveryMethods(variant, quantity);
        });
    };

    this.updateDeliveryMethods = function (variant, quantity) {
        const data = new URLSearchParams({
            variant: variant,
            quantity: quantity,
        });

        fetch(
            globalObject.url + "ajax/ecommerce.php?action=getDeliveryMethods",
            {
                method: "POST",
                body: data,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }
        )
            .then((response) => response.json())
            .then((jsonResponse) => {
                const deliveryMethods = [];
                Object.keys(jsonResponse).forEach((key) => {
                    deliveryMethods.push(jsonResponse[key].id);
                });

                document
                    .querySelectorAll(".delivery-methods ul li")
                    .forEach((li) => {
                        const dataDeliveryMethod = li.dataset.deliverymethod;
                        let show = false;
                        deliveryMethods.forEach((deliveryMethod) => {
                            if (deliveryMethod == dataDeliveryMethod) {
                                show = true;
                            }
                        });

                        if (show) {
                            li.classList.remove("hide");
                        } else {
                            li.classList.add("hide");
                        }
                    });
            })
            .catch((error) => console.error("Error:", error));
    };
}

function PaymentMethods() {
    this.container = document.querySelector(".paymentMethods");

    this.init = function () {
        if (!this.container) return;
        this.handleEvents();
        this.select();
    };

    this.handleEvents = function () {
        // Payment method select
        this.container
            .querySelectorAll("input[type=radio][name=paymentMethod]")
            .forEach((input) => {
                input.addEventListener("change", () => {
                    this.select();
                });
            });

        // Get more info on payment plans
        this.container
            .querySelectorAll(".paymentPlan .moreInfo a")
            .forEach((plan) => {
                plan.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.viewPlanDetails(plan);
                });
            });
    };

    this.select = function () {
        let selectedInput = this.container.querySelector(
            "input[type=radio][name=paymentMethod]:checked"
        );
        let selectedPaymentMethod = selectedInput.closest("li.paymentMethod");

        // Remove selected class on all options
        this.container
            .querySelectorAll("li.paymentMethod.selected")
            .forEach((option) => {
                option.classList.remove("selected");
                option.querySelector(".platform-content").style.display =
                    "none";
            });

        // Add selected class
        selectedPaymentMethod.classList.add("selected");
        selectedPaymentMethod.querySelector(".platform-content").style.display =
            "block";

        // Payment plan select
        selectedPaymentMethod
            .querySelectorAll(".paymentPlans input")
            .forEach((input) => {
                input.addEventListener("change", () => {
                    this.selectPlan(input);
                });
            });
    };

    this.selectPlan = function (selectedPlan) {
        // Remove selected class on all options
        this.container
            .querySelectorAll("li.paymentPlan.selected")
            .forEach((option) => {
                option.classList.remove("selected");
            });

        // Add selected class
        selectedPlan.closest("li.paymentPlan").classList.add("selected");
    };

    this.viewPlanDetails = function (plan) {
        let disclaimer = plan
            .closest(".paymentPlan")
            .querySelector(".disclaimer");
        if (!disclaimer) return;

        if (disclaimer.style.display === "block") {
            disclaimer.style.display = "none";
            plan.innerHTML = "View Details";
        } else {
            disclaimer.style.display = "block";
            plan.innerHTML = "Hide Details";
        }
    };
}

function updateCart(step = null) {
    updateProducts();
    updateProtectionPlans();
    updateTotals(step);
    updateCartQuantity();
    updateDeliveryMethodCouponability();
}

function updateProducts() {
    fetch(globalObject.url + "ajax/ecommerce.php?action=getProducts", {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    })
        .then((response) => response.json())
        .then((jsonResponse) => {
            let pickupQty = 0;
            let shipQty = 0;

            // Run on both cart and checkout
            document
                .querySelectorAll(".cartItem, .summaryProduct")
                .forEach((item) => {
                    let id = item.dataset.variant;
                    let removeItem = true;

                    Object.values(jsonResponse).forEach((value) => {
                        if (value.id == id) {
                            // Cart
                            const cartPriceMsrp =
                                item.querySelector(".cartPriceMsrp");
                            if (cartPriceMsrp)
                                cartPriceMsrp.innerHTML = value.msrp;
                            const cartPriceFinal =
                                item.querySelector(".cartPriceFinal");
                            if (cartPriceFinal)
                                cartPriceFinal.innerHTML = value.price;
                            const shipOpt = item.querySelector(
                                `.shipOpt[value="${value.deliveryType}"]`
                            );
                            if (shipOpt) shipOpt.checked = true;

                            // Checkout order summary
                            const productSize =
                                item.querySelector(".productSize");
                            if (productSize) productSize.innerHTML = value.size;
                            const productTotal =
                                item.querySelector(".productTotal");
                            if (productTotal)
                                productTotal.innerHTML = value.price;
                            const productShipping =
                                item.querySelector(".productShipping");
                            if (productShipping)
                                productShipping.innerHTML = value.shipTitle;

                            removeItem = false;
                        }
                    });

                    if (removeItem) {
                        item.remove();
                    }
                });

            Object.values(jsonResponse).forEach((value) => {
                let addItem = true;
                let addItemType = null;
                let productElements = null;

                if (document.querySelectorAll(".cartItem").length > 0) {
                    // Cart
                    addItemType = 0;
                    productElements = document.querySelectorAll(".cartItem");
                } else if (
                    document.querySelectorAll(".summaryProduct").length > 0
                ) {
                    // Checkout
                    addItemType = 1;
                    productElements =
                        document.querySelectorAll(".summaryProduct");
                }

                productElements.forEach((item) => {
                    let id = item.dataset.variant;

                    if (value.id == id) {
                        addItem = false;
                    }
                });

                if (addItem) {
                    const data = new URLSearchParams({
                        variant: value.id,
                        type: addItemType,
                        count: productElements.length,
                    });

                    fetch(
                        globalObject.url +
                            "ajax/ecommerce.php?action=getProductElement",
                        {
                            method: "POST",
                            body: data,
                            headers: {
                                "Content-Type":
                                    "application/x-www-form-urlencoded",
                            },
                        }
                    )
                        .then((response) => response.text())
                        .then((response) => {
                            if (addItemType == 0) {
                                const shoppingCart = document.querySelector(".shoppingCart");
                                if (shoppingCart) {
                                    shoppingCart.innerHTML += response;
                                    updateStructuredData('cart');
                                }
                            } else if (addItemType == 1) {
                                const summaryProducts =
                                    document.querySelector(".summaryProducts");
                                if (summaryProducts) summaryProducts.innerHTML += response;
                            }
                        })
                        .catch((error) => console.error("Error:", error));
                }

                if (value.deliveryType == "pickup") {
                    pickupQty += parseInt(value.quantity);
                } else {
                    shipQty += parseInt(value.quantity);
                }

                if (shipQty > 0) {
                    document
                        .querySelectorAll(
                            ".shipOptions, .deliveryInstructionsContainer"
                        )
                        .forEach((el) => (el.style.display = "block"));
                } else {
                    document
                        .querySelectorAll(
                            ".shipOptions, .deliveryInstructionsContainer"
                        )
                        .forEach((el) => (el.style.display = "none"));
                }

                if (pickupQty > 0) {
                    document
                        .querySelectorAll(".pickUpStore")
                        .forEach((el) => (el.style.display = "block"));
                } else {
                    document
                        .querySelectorAll(".pickUpStore")
                        .forEach((el) => (el.style.display = "none"));
                }

                // Update quantity of items for delivery/pickup
                document
                    .querySelectorAll(".shipOptions .shippingQty")
                    .forEach(
                        (el) =>
                            (el.innerHTML =
                                shipQty == 1
                                    ? shipQty + " item"
                                    : shipQty + " items")
                    );
                document
                    .querySelectorAll(".pickUpStore .shippingQty")
                    .forEach(
                        (el) =>
                            (el.innerHTML =
                                pickupQty == 1
                                    ? pickupQty + " item"
                                    : pickupQty + " items")
                    );
            });
        })
        .catch((error) => console.error("Error:", error));
}

function updateDeliveryOptionsElement(variant, increment) {
    const data = new URLSearchParams({
        variant: variant,
        increment: increment,
    });

    fetch(
        globalObject.url +
            "ajax/ecommerce.php?action=getDeliveryOptionsElement",
        {
            method: "POST",
            body: data,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        }
    )
        .then((response) => response.text())
        .then((html) => {
            const deliveryOptionsElement = document.querySelector(
                `#cartItem_${variant} .cartShippingOptions`
            );

            if (!deliveryOptionsElement) return;

            if (deliveryOptionsElement.innerHTML !== html) {
                deliveryOptionsElement.innerHTML = html;
            }
        });
}

function updateProtectionPlans() {
    fetch(globalObject.url + "ajax/ecommerce.php?action=getProtectionPlans")
        .then((response) => response.json())
        .then((jsonResponse) => {
            document
                .querySelectorAll(".cartAddons .protectionPlan")
                .forEach((item) => {
                    let id = item.querySelector(".applyProtectionPlan").dataset.plan;
                    let removeItem = true;
                    let itemsCovered = "";

                    Object.values(jsonResponse).forEach((value) => {
                        if (value.id == id) {
                            const amount = item.querySelector(".amount");
                            if (amount) amount.innerHTML = value.amount;
                            Object.values(value.variants).forEach((variant) => {
                                itemsCovered += `<li><strong>${variant.title}</strong></li>`;
                            });

                            removeItem = false;
                        }
                    });

                    if (removeItem) {
                        item.remove();
                    } else {
                        const content = item.querySelector(".content ul");
                        if (content) content.innerHTML = itemsCovered;
                    }
                });

            document
                .querySelectorAll(".cartItem .protectionPlanCartItem")
                .forEach((item) => {
                    let id = item.querySelector(".applyProtectionPlan").dataset.plan;
                    let variant = item.querySelector(".applyProtectionPlan").dataset.variant;
                    let removeItem = true;

                    Object.values(jsonResponse).forEach((value) => {
                        if (value.id == id && value.variants[variant]) {
                            const amount = item.querySelector(".amount");
                            if (amount) amount.innerHTML = value.variants[variant].amount;
                            removeItem = false;
                        }
                    });

                    if (removeItem) {
                        item.remove();
                    }
                });

            document
                .querySelectorAll(".summaryProduct .protectionPlanCartItem")
                .forEach((item) => {
                    let id = item.dataset.plan;
                    let variant = item.dataset.variant;
                    let removeItem = true;

                    Object.values(jsonResponse).forEach((value) => {
                        if (value.id == id && value.variants[variant].isApplied) {
                            const amount = item.querySelector(".amount");
                            if (amount) amount.innerHTML = value.variants[variant].amount;
                            removeItem = false;
                        }
                    });

                    if (removeItem) {
                        item.remove();
                    }
                });

            Object.values(jsonResponse).forEach((value) => {
                let addItem = true;
                let protectionPlanElement = document.querySelectorAll(
                    ".cartAddons .protectionPlan"
                );
                protectionPlanElement.forEach((item) => {
                    let id = item.querySelector(".applyProtectionPlan").dataset.plan;
                    if (value.id == id) {
                        addItem = false;
                    }
                });

                if (addItem) {
                    const data = new URLSearchParams({
                        plan: value.id,
                    });

                    fetch(
                        "/ajax/ecommerce.php?action=getProtectionPlanElement",
                        {
                            method: "POST",
                            body: data,
                            headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                            },
                        }
                    )
                    .then((response) => response.text())
                    .then((response) => {
                        const cartAddons = document.querySelector(".cartAddons");
                        if (cartAddons) cartAddons.innerHTML += response;
                    });
                }
            });

            Object.values(jsonResponse).forEach((value) => {
                let cartItemElement = document.querySelectorAll(".cartItem");
                cartItemElement.forEach((cartItem) => {
                    let addItem = true;
                    let variant = cartItem.dataset.variant;
                    let protectionPlanElement = cartItem.querySelectorAll(
                        ".protectionPlanCartItem"
                    );
                    protectionPlanElement.forEach((item) => {
                        let id = item.querySelector(".applyProtectionPlan").dataset.plan;
                        if (value.id == id && value.variants[variant]) {
                            addItem = false;
                        }
                    });

                    if (addItem) {
                        const data = new URLSearchParams({
                            plan: value.id,
                            variant: variant,
                        });

                        fetch(
                            "/ajax/ecommerce.php?action=getCartItemProtectionPlanElement",
                            {
                                method: "POST",
                                body: data,
                                headers: {
                                    "Content-Type": "application/x-www-form-urlencoded",
                                },
                            }
                        )
                        .then((response) => response.text())
                        .then((response) => {
                            const protectionPlanContainer = cartItem.querySelector(".protectionPlanCartItemContainer");
                            if (protectionPlanContainer) protectionPlanContainer.innerHTML += response;
                        });
                    }
                });
            });

            Object.values(jsonResponse).forEach((value) => {
                let cartItemElement = document.querySelectorAll(".summaryProduct");
                cartItemElement.forEach((cartItem) => {
                    let addItem = true;
                    let variant = cartItem.dataset.variant;
                    let protectionPlanElement = cartItem.querySelectorAll(
                        ".protectionPlanCartItem"
                    );
                    protectionPlanElement.forEach((item) => {
                        let id = item.dataset.plan;
                        if (value.id == id && value.variants[variant]) {
                            addItem = false;
                        }
                    });

                    if (addItem) {
                        const data = new URLSearchParams({
                            plan: value.id,
                            variant: variant,
                        });

                        fetch(
                            "/ajax/ecommerce.php?action=getCheckoutItemProtectionPlanElement",
                            {
                                method: "POST",
                                body: data,
                                headers: {
                                    "Content-Type": "application/x-www-form-urlencoded",
                                },
                            }
                        )
                        .then((response) => response.text())
                        .then((response) => {
                            const protectionPlanContainer = cartItem.querySelector(".protectionPlanCartItemContainer");
                            if (protectionPlanContainer) protectionPlanContainer.innerHTML += response;
                        });
                    }
                });
            });
        })
        .catch((error) => console.error("Error:", error));
}

/**
 * Creates a new aside coupon element that uses Alpine to show disclaimer/description.
 *
 * @param {Object} coupon - The coupon object.
 * @returns {HTMLElement} The newly created aside coupon element.
 */
function createNewAsideCoupon(coupon) {
    const newCoupon = document.createElement("div");
    newCoupon.id = `asideCoupon-${coupon.id}`;
    newCoupon.classList.add("asideCoupon");
    newCoupon.setAttribute("x-data", "{ open: false }"); // Add Alpine.js data attribute

    const cartOverviewData = document.createElement("div");
    cartOverviewData.id = `cartOverviewDataCoupon_${coupon.id}`;
    cartOverviewData.classList.add("cartOverviewData");

    const asideLabel = document.createElement("span");
    asideLabel.classList.add("asideLabel", "couponLabel");

    // More info SVG icon with click event listener
    const svgSpan = document.createElement("span");
    svgSpan.id = "couponInfoSvg";
    svgSpan.classList.add("moreInfo", "svg-icon", "svg-ecomm-green");
    svgSpan.setAttribute("x-on:click", "open = !open"); // Add Alpine.js click event listener
    svgSpan.style.userSelect = "none";
    // Add info icon svg
    svgSpan.innerHTML = `<svg width="30" height="30" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1152 1376v-160q0-14-9-23t-23-9h-96v-512q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v160q0 14 9 23t23 9h96v320h-96q-14 0-23 9t-9 23v160q0 14 9 23t23 9h448q14 0 23-9t9-23zm-128-896v-160q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v160q0 14 9 23t23 9h192q14 0 23-9t9-23zm640 416q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"></path></svg>`;

    // Remove coupon span element
    const removeCoupon = document.createElement("span");
    removeCoupon.classList.add("removeCoupon");
    removeCoupon.dataset.coupon = coupon.id;
    removeCoupon.textContent = "Remove";

    // Coupon code span element
    const couponCode = document.createElement("span");
    couponCode.classList.add("couponCode");
    couponCode.textContent = coupon.couponCode;
    couponCode.append(svgSpan);

    asideLabel.textContent = "Coupon ";
    asideLabel.append(couponCode, removeCoupon);

    const asideValue = document.createElement("span");
    asideValue.classList.add("asideValue", "couponDiscount");
    asideValue.textContent = coupon.couponDiscount ? `-${coupon.couponDiscount}` : "";

    cartOverviewData.append(asideLabel, asideValue);
    newCoupon.append(cartOverviewData);

    const expandInfo = document.createElement("div");
    expandInfo.setAttribute("x-show", "open");

    const alertBanner = document.createElement("div");
    alertBanner.classList.add("alertBanner");

    if (coupon.description) {
        const description = document.createElement("div");
        description.classList.add("description");
        description.innerHTML = coupon.description;
        alertBanner.append(description);
    }

    if (coupon.disclaimer) {
        const disclaimer = document.createElement("div");
        disclaimer.classList.add("disclaimer");
        disclaimer.innerHTML = coupon.disclaimer;
        alertBanner.append(disclaimer);
    }

    expandInfo.append(alertBanner);
    newCoupon.append(expandInfo);

    return newCoupon;
}

function updateTotals(step = null) {
    fetch(globalObject.url + "ajax/ecommerce.php?action=getTotals", {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: step ? new URLSearchParams({ step: step }) : null,
    })
        .then((response) => response.json())
        .then((jsonResponse) => {
            // Coupons
            if (jsonResponse.coupons && !Array.isArray(jsonResponse.coupons)) {
                Object.entries(jsonResponse.coupons).forEach(
                    ([key, coupon]) => {
                        const noShippingOrDeliveryDiscount =
                            !coupon.discountShipping &&
                            !coupon.discountDelivery &&
                            (!coupon.discountTarget || coupon.discountTarget == 0 || coupon.discountTarget == 4);

                        if (key !== "allCouponsAmount") {
                            const couponEl = document.querySelectorAll(
                                `#asideCoupon-${key}`
                            );
                            if (couponEl.length > 0) {
                                if (noShippingOrDeliveryDiscount) {
                                    // Update new coupon value
                                    couponEl.forEach((el) => {
                                        let couponDiscount =
                                            el.querySelector(".couponDiscount");
                                        if (couponDiscount)
                                            couponDiscount.innerHTML = `-${coupon.couponAmount}`;
                                    });
                                }
                            } else {
                                coupon.couponDiscount =
                                    noShippingOrDeliveryDiscount
                                        ? `${coupon.couponAmount}`
                                        : "";

                                const newCoupon = createNewAsideCoupon(coupon);
                                const asideCoupons =
                                    document.querySelector(".asideCoupons");
                                if (asideCoupons) {
                                    asideCoupons.append(newCoupon);
                                    asideCoupons.classList.remove("couponHide");
                                }
                            }
                        }
                    }
                );

                document.querySelectorAll(".asideCoupon").forEach((item) => {
                    let id = item.id.split("-")[1];
                    let removeItem = true;
                    Object.values(jsonResponse.coupons).forEach((coupon) => {
                        if (coupon.id == id) {
                            removeItem = false;
                        }
                    });

                    if (removeItem) {
                        item.remove();
                    }
                });
            } else {
                let asideCoupons = document.querySelector(".asideCoupons");
                if (asideCoupons) {
                    asideCoupons.classList.add("couponHide");
                }
            }

            // Protection plans
            if (jsonResponse.protectionPlans) {
                Object.entries(jsonResponse.protectionPlans).forEach(
                    ([id, plan]) => {
                        const planEl = Array.from(
                            document.querySelectorAll(".asideProtectionPlan")
                        ).find((el) => el.dataset.plan === id);

                        if (planEl) {
                            // Check for protection plans that no longer apply
                            if (plan.amount == "0.00" || plan.isApplied == 0) {
                                planEl.classList.add("hide");
                                document.querySelectorAll(
                                    ".cartAddons .addon.protectionPlan .price .addToCart"
                                ).forEach((el) => {
                                    if (
                                        el.querySelector(".applyProtectionPlan").dataset.plan === id
                                    ) {
                                        el.classList.remove("hide");
                                        let prevEl = el.previousElementSibling;
                                        if (
                                            prevEl &&
                                            prevEl.classList.contains("isApplied")
                                        ) {
                                            prevEl.classList.add("hide");
                                        }
                                    }
                                });
                                document.querySelectorAll(
                                    ".cartItem .protectionPlanCartItem .addToCart"
                                ).forEach((el) => {
                                    if (
                                        el.querySelector( ".applyProtectionPlan").dataset.plan === id
                                    ) {
                                        el.classList.remove("hide");
                                        let prevEl = el.previousElementSibling;
                                        if (
                                            prevEl &&
                                            prevEl.classList.contains("isApplied")
                                        ) {
                                            prevEl.classList.add("hide");
                                        }
                                    }
                                });
                            }
                            if (plan.isApplied == 1) {
                                planEl.classList.remove("hide");
                            }
                            // Update new protection plan value
                            let asideValue =
                                planEl.querySelector(".asideValue");
                            if (asideValue) {
                                asideValue.innerHTML = plan.amount;
                            }
                        } else {
                            // Protection plan doesn't exist on page, create element
                            let hideElement = plan.isApplied ? "" : "hide";
                            const planElNew = document.createElement("div");
                            planElNew.classList.add(
                                "asideProtectionPlan",
                                hideElement
                            );
                            planElNew.dataset.plan = id;
                            planElNew.innerHTML = `<div class="cartOverviewData">
                            <span class="asideLabel">
                                ${plan.title} <span class="removeProtectionPlan">Remove</span>
                            </span>
                            <span class="asideValue">${plan.amount}</span>
                        </div>`;

                            let asideProtectionPlans = document.querySelector(
                                ".asideProtectionPlans"
                            );
                            if (asideProtectionPlans) {
                                asideProtectionPlans.append(planElNew);
                            }
                        }

                        document
                            .querySelectorAll(".asideProtectionPlan")
                            .forEach((item) => {
                                let id = item.dataset.plan;
                                let removeItem = true;
                                Object.values(
                                    jsonResponse.protectionPlans
                                ).forEach((plan) => {
                                    if (plan.id == id) {
                                        removeItem = false;
                                    }
                                });

                                if (removeItem) {
                                    item.remove();
                                }
                            });
                    }
                );
            } else {
                document
                    .querySelectorAll(".asideProtectionPlan")
                    .forEach((item) => {
                        item.classList.add("hide");
                    });
            }

            // Cart Totals
            const estimated = jsonResponse.estimated ? "Estimated " : "";
            let titleQty = document.querySelector(".cartContainer .title-qty");
            if (titleQty) {
                titleQty.innerHTML = jsonResponse.totalQuantity;
            }
            let titleSubtotal = document.querySelector(
                ".cartContainer .title-subtotal"
            );
            if (titleSubtotal) {
                titleSubtotal.innerHTML = jsonResponse.subtotal;
            }
            let cartOverviewSubtotal = document.querySelector(
                ".cartOverview .subtotal"
            );
            if (cartOverviewSubtotal) {
                cartOverviewSubtotal.innerHTML = jsonResponse.subtotal;
            }
            let shipping = document.querySelector(".cartOverview .shipping");
            if (shipping) {
                let shippingHtml = "";
                if (jsonResponse.shippingOriginal) {
                    shippingHtml += `<s>${jsonResponse.shippingOriginal}</s> `;
                }
                shippingHtml += jsonResponse.shipping;
                shipping.innerHTML = shippingHtml;
                let shippingLabel =
                    shipping.parentElement.querySelector(".asideLabel");
                if (shippingLabel) {
                    shippingLabel.innerHTML =
                        estimated +
                        shippingLabel.textContent.replace("Estimated", "");
                }
            }
            let delivery = document.querySelector(".cartOverview .delivery");
            if (delivery) {
                let deliveryHtml = "";
                if (jsonResponse.deliveryOriginal) {
                    deliveryHtml += `<s>${jsonResponse.deliveryOriginal}</s> `;
                }
                deliveryHtml += jsonResponse.delivery;
                delivery.innerHTML = deliveryHtml;
                let deliveryLabel =
                    delivery.parentElement.querySelector(".asideLabel");
                if (deliveryLabel) {
                    deliveryLabel.innerHTML =
                        estimated +
                        deliveryLabel.textContent.replace("Estimated", "");
                }
            }
            let tax = document.querySelector(".cartOverview .tax");
            if (tax) {
                tax.innerHTML = jsonResponse.tax;
                let taxLabel = tax.parentElement.querySelector(".asideLabel");
                if (taxLabel) {
                    taxLabel.innerHTML =
                        estimated + taxLabel.innerHTML.replace("Estimated", "");
                }
            }
            let estimatedTotal = document.querySelector(
                ".estimatedTotal .asideValue"
            );
            if (estimatedTotal) {
                estimatedTotal.innerHTML = jsonResponse.total;
            }

            // Checkout order summary
            let summarySubtotal = document.querySelector(
                ".summaryTotals .subtotal"
            );
            if (summarySubtotal) {
                summarySubtotal.innerHTML = jsonResponse.subtotal;
            }
            let summaryShipping = document.querySelector(
                ".summaryTotals .shipping"
            );
            if (summaryShipping) {
                summaryShipping.innerHTML = jsonResponse.shipping;
            }
            let summaryDelivery = document.querySelector(
                ".summaryTotals .delivery"
            );
            if (summaryDelivery) {
                summaryDelivery.innerHTML = jsonResponse.delivery;
            }
            let summaryTax = document.querySelector(".summaryTotals .tax");
            if (summaryTax) {
                summaryTax.innerHTML = jsonResponse.tax;
            }
            let summaryTotal = document.querySelector(".summaryTotals .total");
            if (summaryTotal) {
                summaryTotal.innerHTML = jsonResponse.total;
            }

            if (jsonResponse.hasShipping) {
                document
                    .querySelectorAll(".cartOverview .shipping")
                    .forEach((el) => {
                        el.parentElement.classList.remove("hide");
                    });
                document
                    .querySelectorAll(".summaryTotals .shipping")
                    .forEach((el) => {
                        el.parentElement.classList.remove("hide");
                    });
            } else {
                document
                    .querySelectorAll(".cartOverview .shipping")
                    .forEach((el) => {
                        el.parentElement.classList.add("hide");
                    });
                document
                    .querySelectorAll(".summaryTotals .shipping")
                    .forEach((el) => {
                        el.parentElement.classList.add("hide");
                    });
            }

            if (jsonResponse.hasDelivery) {
                document
                    .querySelectorAll(".cartOverview .delivery")
                    .forEach((el) => {
                        el.parentElement.classList.remove("hide");
                    });
                document
                    .querySelectorAll(".summaryTotals .delivery")
                    .forEach((el) => {
                        el.parentElement.classList.remove("hide");
                    });
            } else {
                document
                    .querySelectorAll(".cartOverview .delivery")
                    .forEach((el) => {
                        el.parentElement.classList.add("hide");
                    });
                document
                    .querySelectorAll(".summaryTotals .delivery")
                    .forEach((el) => {
                        el.parentElement.classList.add("hide");
                    });
            }

            let orderTotal = document.querySelector("#billingForm #orderTotal");
            if (orderTotal) {
                orderTotal.value = jsonResponse.total;
            }

            let affirmTotalElement = document.querySelector('.cartOverview .affirm-as-low-as');
            if (affirmTotalElement) {
                let affirmTotal = parseInt(jsonResponse.total.replace('$','').replace(',','').replace('.',''));
                affirmTotalElement.setAttribute('data-amount', affirmTotal);
                affirm.ui.ready(function() {
                    affirm.ui.refresh();
                });
            }
        })
        .catch((error) => console.error("Error:", error));
}

function updateCartQuantity() {
    fetch(globalObject.url + "ajax/ecommerce.php?action=getCartQuantity")
        .then((response) => response.text())
        .then((newQty) => {
            document.querySelectorAll(".cartQuantity").forEach((cartQuantity) => {
                cartQuantity.innerHTML = newQty;
                if(cartQuantity)

                if (newQty > 0) {
                    cartQuantity.classList.remove("noCartQuantity");
                } else {
                    cartQuantity.classList.add("noCartQuantity");
                }
            });
        })
        .catch((error) => console.error("Error:", error));
}

/**
 * Updates the delivery coupon status messages on the cart page that indicate
 * whether or not the currently chosen delivery method is 'covered' by any
 * delivery coupon that might be present on the current cart.
 */
async function updateDeliveryMethodCouponability() {
    const { hasDeliveryCoupon, eligibleDeliveryMethods } = await fetch(
        "/ajax/ecommerce.php?action=getEligibleCouponDeliveryMethods"
    ).then((result) => result.json());

    if (!hasDeliveryCoupon) {
        // Hide all delivery coupon inelegbility messages.
        [
            ...document.getElementsByClassName(
                "deliveryCouponIneligbilityMessage"
            ),
        ].forEach((div) => (div.style.display = "none"));

        return;
    }

    const cartItems = [
        ...document.querySelectorAll(".shoppingCart > .cartItem"),
    ];

    for (const cartItem of cartItems) {
        const selectedDeliveryMethod = parseInt(
            [...cartItem.querySelectorAll("input.shipOpt")].find(
                (input) => input.checked
            ).value
        );

        // true if the current cartItem's currently selected delivery method is
        // eligible to be discounted by a delivery coupon on the current cart
        const isEligible = eligibleDeliveryMethods.includes(
            selectedDeliveryMethod
        );

        const messageElement = cartItem.querySelector(
            ".deliveryCouponIneligbilityMessage"
        );

        if (isEligible) messageElement.style.display = "none";
        else messageElement.style.display = "";
    }
}

// TODO: Add css for transition
function goToPage(page, push) {
    if (window.location.pathname.indexOf("checkout") !== -1) {
        let step = "";

        //Only run this on checkout pages
        if (page == "shipping") {
            //Collapse shipping layout to remove editable fields
            updateShippingLayout("edit");
            // Hide edit button
            let editBtn = document.querySelector(
                ".checkoutBoxHeader a#shippingEdit"
            );
            if (editBtn) editBtn.classList.add("hiddenCheckoutSection");

            // Remove continue to payment button
            let checkoutBtn = document.querySelector(
                "#shippingForm .checkoutButton"
            );
            if (checkoutBtn) checkoutBtn.style.display = "block";

            // Show shipping box
            let shippingBox = document.querySelector("#shippingBox");
            if (shippingBox) {
                shippingBox.style.display = "block";

                // Scroll to shipping section
                const offsetTop =
                    shippingBox.getBoundingClientRect().top +
                    window.scrollY -
                    150;
                window.scrollTo({ top: offsetTop, behavior: "smooth" });
            }

            // Hide billing box
            let billingBox = document.querySelector("#billingBox");
            if (billingBox) billingBox.style.display = "none";

            if (push) {
                window.history.pushState(
                    "{step: payment}",
                    "",
                    globalObject.url + "checkout"
                );
            }
        } else if (page == "billing") {
            // Remove continue to payment button
            let checkoutBtn = document.querySelector(
                "#shippingForm .checkoutButton"
            );
            if (checkoutBtn) checkoutBtn.style.display = "none";

            // Collapse shipping layout to remove editable fields
            updateShippingLayout("edit");

            // Show edit button
            let editBtn = document.querySelector(
                ".checkoutBoxHeader a#shippingEdit"
            );
            if (editBtn) editBtn.classList.remove("hiddenCheckoutSection");

            // Hide shipping box
            let shippingBox = document.querySelector("#shippingBox");
            if (shippingBox) shippingBox.style.display = "none";

            // Show billing box
            let billingBox = document.querySelector("#billingBox");
            if (billingBox) {
                billingBox.style.display = "block";

                // Scroll to billing section
                const offsetTop =
                    billingBox.getBoundingClientRect().top +
                    window.scrollY -
                    150;
                window.scrollTo({ top: offsetTop, behavior: "smooth" });
            }

            step = "payment";
            if (push) {
                window.history.pushState(
                    "{step: payment}",
                    "",
                    globalObject.url + "checkout/" + step
                );
                pushToDataLayer("payment");
            }
        }
        updateCart(step);
    }
}

function updateShippingLayout(view) {
    const shippingForm = document.querySelector("form#shippingForm");
    if (!shippingForm) return;

    switch (view) {
        case "quick":
            // Email
            let email = shippingForm.querySelector("input[name=email]");
            if (email) {
                email.classList.add("editView");
                email.style.display = "none";
                email.insertAdjacentHTML(
                    "afterend",
                    `<span class="email quickView">${email.value}</span>`
                );
            }

            // Create new account
            let createAccountContainer = shippingForm.querySelector(
                ".createAccountContainer"
            );
            if (createAccountContainer) {
                createAccountContainer.classList.add("editView");
                createAccountContainer.style.display = "none";
            }

            // Saved addresses are present
            let savedAddressContainer = shippingForm.querySelector(
                ".savedAddressContainer"
            );
            if (savedAddressContainer) {
                savedAddressContainer
                    .querySelectorAll(".savedAddress")
                    .forEach((el) => {
                        el.classList.add("editView");
                        el.style.display = "none";
                    });

                let selectedAddress = savedAddressContainer.querySelector(
                    ".savedAddress.selectedAddress .savedAddressInfo"
                );
                if (selectedAddress) {
                    savedAddressContainer.insertAdjacentHTML(
                        "beforeend",
                        `<span class="quickView">${selectedAddress.innerHTML}</span>`
                    );
                }
            }

            // Shipping fields are present
            let shippingFields = shippingForm.querySelector(".shipFields");
            if (shippingFields) {
                let newLineFields = [
                    "last",
                    "phone",
                    "address",
                    "address2",
                    "zip",
                ];
                shippingFields.querySelectorAll(".input").forEach((el) => {
                    let formField =
                        el.querySelector("input") || el.querySelector("select");
                    let name = formField.getAttribute("name");
                    let val =
                        name.indexOf("phone") !== -1
                            ? formatPhone(formField.value)
                            : formField.value;
                    el.classList.add("editView");
                    el.style.display = "none";
                    el.insertAdjacentHTML(
                        "afterend",
                        `<span class="quickView">${val} ${
                            newLineFields.indexOf(name) !== -1 && val.length > 0
                                ? "<br>"
                                : ""
                        }</span>`
                    );
                });
            }

            // Add new address link
            let newAddress = shippingForm.querySelector(".newAddress");
            if (newAddress) {
                newAddress.classList.add("editView");
                newAddress.style.display = "none";
            }

            // Store pickup
            let pickUpStore = shippingForm.querySelector(".pickUpStore");
            if (pickUpStore) {
                let changeStore = pickUpStore.querySelector(".changeStore");
                if (changeStore) {
                    changeStore.classList.add("editView");
                    changeStore.style.display = "none";
                }
            }

            // Delivery instructions
            let deliveryInstructions = shippingForm.querySelector(
                "#deliveryInstructions"
            );
            if (deliveryInstructions) {
                deliveryInstructions.classList.add("editView");
                deliveryInstructions.style.display = "none";
                deliveryInstructions.insertAdjacentHTML(
                    "afterend",
                    `<span class="email quickView">${
                        deliveryInstructions.value.length
                            ? deliveryInstructions.value
                            : "(none)"
                    }</span>`
                );
            }

            // Billing address
            let differentAddress = document.querySelector(
                "input[name=differentAddress]"
            );
            if (
                differentAddress &&
                !differentAddress.checked &&
                document.querySelector(
                    "section.section-Shipping .pickUpStore"
                ) == null
            ) {
                let billingAddress =
                    '<h4 class="quickView">Billing Address</h4><br>';
                // Copy shipping address & display as billing
                shippingFields.querySelectorAll(".quickView").forEach((el) => {
                    billingAddress += el.innerHTML;
                });
                let billingSection = document.querySelector(
                    "#billingForm section.billingSection"
                );
                if (billingSection) {
                    billingSection.insertAdjacentHTML(
                        "afterbegin",
                        `<div class="billingAddress quickView">${billingAddress}</div>`
                    );
                }
            }
            break;
        case "edit":
            shippingForm
                .querySelectorAll(".quickView")
                .forEach((el) => el.remove());
            shippingForm
                .querySelectorAll(".editView")
                .forEach((el) => (el.style.display = "block"));

            let billingForm = document.querySelector("form#billingForm");
            if (billingForm) {
                billingForm
                    .querySelectorAll(".quickView")
                    .forEach((el) => el.remove());
                billingForm
                    .querySelectorAll(".editView")
                    .forEach((el) => (el.style.display = "block"));
            }

            break;
    }
}

cardFromNumber = function (num) {
    var card, j, len;
    num = (num + "").replace(/\D/g, "");
    for (j = 0, len = cards.length; j < len; j++) {
        card = cards[j];
        if (card.pattern.test(num)) {
            return card.type;
        }
    }
};

luhnCheck = function (num) {
    var digit, digits, j, len, odd, sum;
    odd = true;
    sum = 0;
    digits = (num + "").split("").reverse();
    for (j = 0, len = digits.length; j < len; j++) {
        digit = digits[j];
        digit = parseInt(digit, 10);
        if ((odd = !odd)) {
            digit *= 2;
        }
        if (digit > 9) {
            digit -= 9;
        }
        sum += digit;
    }
    return sum % 10 === 0;
};

function getDeliveryRangeMessage(option = "pickup") {
    let list = "<ul>";
    document.querySelectorAll(".summaryProduct").forEach((product) => {
        const productShipping = product.querySelector(".productShipping");
        if (productShipping) {
            if (option == 'quote') {
                const productTitle = product.querySelector(".productTitle");
                if (productTitle) list += `<li>${productTitle.innerText}</li>`;
            } else if (productShipping.dataset.type === "delivery") {
                const productTitle = product.querySelector(".productTitle");
                if (productTitle) list += `<li>${productTitle.innerText}</li>`;
            }
        }
    });
    list += "</ul>";

    let message;
    if (option == "pickup") {
        message =
            '<div class="alertBanner info checkoutError deliveryRangeError"><span><p>It looks like you\'re outside our delivery range. Please edit the shipping address or choose to pick up the following item(s) instead.</p>' +
            list +
            '</span><br><button type="button" class="editShipping">Edit shipping address</button><button type="button" class="pickupItems">Pick up instead</button></div>';
    } else if (option == "quote") {
        message =
            '<div class="alertBanner info checkoutError deliveryRangeError"><span><p>It looks like you\'re outside our delivery range. Please edit the shipping address or request a quote for the following item(s) instead.</p>' +
            list +
            '</span><br><button type="button" class="editShipping">Edit shipping address</button><button type="button" class="requestQuote">Request quote instead</button></div>';
    }
    return message;
}



function getDeliveryMethodMessage(variants) {
    var list = "<ul>";
    var listCount = 0;
    for (i = 0; i < variants.length; i++) {
        list += "<li>" + variants[i].title + "</li>";
        listCount++;
    }
    list += "</ul>";
    var message =
        '<div class="alertBanner info checkoutError deliveryMethodError"><span><p>The selected delivery option for the following item(s) is no longer available.</p>' +
        list +
        '<p>Please return to the cart and choose from the available delivery options.</p></span><br><button type="button" class="returnToCart">Return to Cart</button></div>';
    return message;
}

function handleCheckoutFormEvents() {
    const checkoutForm = document.querySelector(".checkoutForm");
    if (!checkoutForm) return;

    checkoutForm.addEventListener("click", function (e) {
        if (e.target.classList.contains("editShipping")) {
            hideClosestAlertBanner(e.target);
        } else if (e.target.classList.contains("pickupItems")) {
            handlePickupItems(e.target);
        } else if(e.target.classList.contains("requestQuote")) {
            handleRequestQuote(e.target);
        }else if (e.target.classList.contains("returnToCart")) {
            handleReturnToCart();
        }
    });
}

function handleRequestQuote(target) {
    hideClosestAlertBanner(target);

    fetch(globalObject.url + "ajax/ecommerce.php?action=changeDeliveryToRequestQuote", {
            method: "POST",
        })
    .then((response) => response.text())
    .then(() => {
        updateCart();
    })
    .finally(() => {
        document.getElementById("billingCheckbox").style.display = "none";
        document.querySelector("#continueToPaymentButton").click();
        const paymentMethods = document.querySelectorAll(".paymentMethods li");
        paymentMethods.forEach((method) => {
            if (!method.classList.contains("platform-requestquote")) {
                method.classList.add("hiddenField");
                method.classList.remove("selected");
            } else {
                method.classList.add("selected");
                const methodContent = method.querySelector(".platform-content");
                if (methodContent) methodContent.style.display = "block";
                const radioInput = method.querySelector("input[type='radio']");
                if (radioInput) radioInput.checked = true;
            }
        });
    })
    .catch((error) => console.error("Error:", error));
}

function handlePickupItems(target) {
    hideClosestAlertBanner(target);

    fetch(
        globalObject.url + "ajax/ecommerce.php?action=changeDeliveryToPickup",
        {
            method: "POST",
        }
    )
        .then((response) => response.text())
        .then(() => {
            updateCart();
            document.getElementById("billingCheckbox").style.display = "none";
            const billingInfo = document.querySelector(".billingInfo");
            if (billingInfo) {
                billingInfo.classList.remove("hiddenField");
                billingInfo.style.display = "block";
            }
        })
        .catch((error) => console.error("Error:", error));
}

function handleReturnToCart() {
    window.location.href = "/cart";
}

function handleExternalCartParams() {
    const url = new URL(window.location);
    if (!url.searchParams.has("products")) return;

    url.searchParams.delete("products");
    url.searchParams.delete("coupon");
    history.replaceState(null, "", url.pathname + (url.search || ""));
}

function handleShoppingCartEvents() {
    const shoppingCart = document.querySelector(".shoppingCart");
    if (!shoppingCart) return;

    // Update quantity on select change
    shoppingCart.addEventListener("change", (e) => {
        if (e.target.matches(".quantitySelect")) {
            handleQuantitySelectChange(e.target);
        }
    });

    // Remove item
    shoppingCart.addEventListener("click", (e) => {
        if (e.target.closest(".removeItem")) {
            e.preventDefault();
            handleRemoveItem(e.target.closest(".removeItem"));
        }
    });
}

function handleQuantitySelectChange(target) {
    let localVariantId = parseInt(target.closest(".cartItem").dataset.variant);
    let increment = parseInt(target.closest(".cartItem").dataset.increment);
    let quantity = target.value;

    const data = new URLSearchParams({
        quantity: quantity,
        variant: localVariantId,
    });

    const productObject = V5_STRUCTURED_DATA.cart.products.find(
        (product) => product.local_id === localVariantId
    );

    const oldQuantity = productObject.quantity;
    productObject.quantity = quantity;
    const quantityDelta = quantity - oldQuantity;

    if (quantityDelta > 0) {
        GoogleAnalytics.onAddToCart(localVariantId, quantityDelta);
    } else if (quantityDelta < 0) {
        GoogleAnalytics.onRemoveFromCart(localVariantId, -quantityDelta);
    }

    fetch(globalObject.url + "ajax/ecommerce.php?action=updateQuantity", {
        method: "POST",
        body: data,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    })
        .then((response) => response.text())
        .then((response) => {
            updateCart();
            updateDeliveryOptionsElement(localVariantId, increment);
        })
        .catch((error) => console.error("Error:", error));
}

function handleRemoveItem(target) {
    const localVariantId = parseInt(
        target.closest(".cartItem").dataset.variant
    );

    const data = new URLSearchParams({
        quantity: 0,
        variant: localVariantId,
    });

    pushToDataLayer("removeFromCart", localVariantId);

    const productObject = V5_STRUCTURED_DATA.cart.products.find(
        (product) => product.local_id === localVariantId
    );

    GoogleAnalytics.onRemoveFromCart(localVariantId, productObject.quantity);

    V5_STRUCTURED_DATA.cart.products = V5_STRUCTURED_DATA.cart.products.filter(
        (product) => product.local_id !== localVariantId
    );

    showLoadingOverlay();
    fetch(globalObject.url + "ajax/ecommerce.php?action=updateQuantity", {
        method: "POST",
        body: data,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    })
        .then((response) => response.text())
        .then((response) => {
            if (response == "0") {
                //Reload if cart is empty.
                window.location.reload();
            } else {
                updateCart();
            }
        })
        .catch((error) => console.error("Error:", error))
        .finally(() => hideLoadingOverlay());
}

function handleApplyCoupon() {
    const applyCouponButton = document.querySelector(".applyCouponButton");
    if (!applyCouponButton) return;

    applyCouponButton.addEventListener("click", (e) => {
        const couponField = document.querySelector("#couponField");
        const couponCode = couponField.value;
        const couponMessage = document.querySelector(".couponMessage");
        const data = new URLSearchParams({
            coupon: couponCode,
        });

        fetch(globalObject.url + "ajax/ecommerce.php?action=applyCoupon", {
            method: "POST",
            body: data,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        })
            .then((response) => response.text())
            .then((response) => {
                // Reset coupon input
                couponField.value = "";

                if (response == "true") {
                    // Remove coupon message if needed
                    if (couponMessage) {
                        couponMessage.innerHTML = "";
                    }
                    updateCart();
                } else {
                    if (couponMessage) {
                        couponMessage.innerHTML = `Coupon code <span style="font-style: italic; font-weight: bold;">${couponCode}</span> is expired, invalid, or may not apply to some items in your cart.`;
                    }
                }
            })
            .catch((error) => console.error("Error:", error));
    });
}

function handleRemoveCoupon() {
    const asideCoupons = document.querySelector(".asideCoupons");
    if (!asideCoupons) return;

    asideCoupons.addEventListener("click", (e) => {
        if (e.target.classList.contains("removeCoupon")) {
            const coupon = e.target.dataset.coupon;
            const data = new URLSearchParams({
                coupon: coupon,
            });

            fetch(globalObject.url + "ajax/ecommerce.php?action=removeCoupon", {
                method: "POST",
                body: data,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            })
                .then((response) => response.text())
                .then((response) => {
                    // TODO: Add css for transition
                    e.target.closest(".asideCoupon").remove();
                    updateCart();
                })
                .catch((error) => console.error("Error:", error));
        }
    });
}

function handleCartAddons() {
    const cartAddons = document.querySelector(".cartAddons");
    const cartItemProtectionPlans = document.querySelectorAll(".protectionPlanCartItemContainer");
    const cartOverview = document.querySelector(".cartOverview");

    if (cartAddons) {
        // Handle add protection plan to cart
        cartAddons.addEventListener("click", (e) => {
            if (e.target.classList.contains('applyProtectionPlan')) {
                e.preventDefault();
                addProtectionPlanToCart(e.target.dataset.plan);
            }
        });
    }
    if (cartItemProtectionPlans) {
        // Handle add protection plan to cart
        cartItemProtectionPlans.forEach((cartItemPlan) => {
            cartItemPlan.addEventListener("click", (e) => {
                if (e.target.classList.contains('applyCartItemProtectionPlan')) {
                    e.preventDefault();
                    addProtectionPlanToCart(e.target.dataset.plan, e.target.dataset.variant);
                }
                if (e.target.classList.contains('isAppliedRemove')) {
                    let applyElement = e.target.closest(".protectionPlanCartItem").querySelector("a.applyProtectionPlan");
                    let plan = applyElement.dataset.plan;
                    let variant = applyElement.dataset.variant;
                    removeProtectionPlanFromCart(plan, variant);
                }
            });
        });
    }

    // Handle remove protection plan from cart
    if (cartOverview) {
        cartOverview
            .querySelectorAll(".asideProtectionPlan")
            .forEach((plan) => {
                plan.addEventListener("click", (e) => {
                    e.preventDefault();
                    removeProtectionPlanFromCart(plan.dataset.plan);
                });
            });
    }
}

function addProtectionPlanToCart(plan, variant=null) {
    const data = new URLSearchParams({
        plan: plan,
        variant: variant,
    });

    fetch("/ajax/ecommerce.php?action=applyProtectionPlan", {
        method: "POST",
        body: data,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    })
        .then((response) => response.text())
        .then((response) => {
            // Update cart aside
            document
                .querySelectorAll(".cartAside .asideProtectionPlan")
                .forEach((el) => {
                    if (el.dataset.plan == plan) {
                        el.classList.remove("hide");
                    }
                });
            // Make sure you can't add it again
            let addToCartQuerySelector = ".cartAddons .addon.protectionPlan .price .addToCart";
            if (variant) {
                let cartItemPlanSelector = "#cartItem_"+variant+" .protectionPlanCartItem[data-plan='"+plan+"']";
                addToCartQuerySelector = cartItemPlanSelector+" .addToCart";
                document.querySelector(cartItemPlanSelector).querySelector(".protectionPlanIcon.applied").classList.remove("hide");
                document.querySelector(cartItemPlanSelector).querySelector(".protectionPlanIcon.notApplied").classList.add("hide");
            }
            document
                .querySelectorAll(
                    addToCartQuerySelector
                )
                .forEach((el) => {
                    let applyPlan = el.querySelector(".applyProtectionPlan");
                    if (applyPlan && applyPlan.dataset.plan == plan) {
                        el.classList.add("hide");
                        let prevEl = el.previousElementSibling;
                        if (prevEl && prevEl.classList.contains("isApplied")) {
                            prevEl.classList.remove("hide");
                        }
                    }
                });

            updateCart();
        })
        .catch((error) => console.error("Error:", error));
}

function removeProtectionPlanFromCart(plan, variant=null) {
    const data = new URLSearchParams({
        plan: plan,
        variant: variant,
    });

    fetch("/ajax/ecommerce.php?action=removeProtectionPlan", {
        method: "POST",
        body: data,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    })
        .then((response) => response.text())
        .then((response) => {
            // Update cart aside
            document.querySelector(".asideProtectionPlan[data-plan='"+plan+"']").classList.add("hide");

            // Make sure you can add it again
            let addToCartQuerySelector = ".cartAddons .addon.protectionPlan .price .addToCart";
            if (variant) {
                let cartItemPlanSelector = "#cartItem_"+variant+" .protectionPlanCartItem[data-plan='"+plan+"']";
                addToCartQuerySelector = cartItemPlanSelector+" .addToCart";
                document.querySelector(cartItemPlanSelector).querySelector(".protectionPlanIcon.applied").classList.add("hide");
                document.querySelector(cartItemPlanSelector).querySelector(".protectionPlanIcon.notApplied").classList.remove("hide");
            }
            document
                .querySelectorAll(
                    addToCartQuerySelector
                )
                .forEach((el) => {
                    let applyPlan = el.querySelector(".applyProtectionPlan");
                    if (
                        applyPlan &&
                        applyPlan.dataset.plan == plan
                    ) {
                        el.classList.remove("hide");
                        let prevEl = el.previousElementSibling;
                        if (prevEl && prevEl.classList.contains("isApplied")) {
                            prevEl.classList.add("hide");
                        }
                    }
                });

            updateCart();
        })
        .catch((error) => console.error("Error:", error));
}

function handleUpdateShippingOption() {
    const shoppingCart = document.querySelector(".shoppingCart");
    if (!shoppingCart) return;

    shoppingCart.addEventListener("change", (e) => {
        if (e.target.matches(".shippingOption input")) {
            const value = parseInt(e.target.value);
            const shippingOption = e.target.closest(".shippingOption");
            const variantId = parseInt(
                e.target.closest(".cartItem").dataset.variant
            );

            const data = new URLSearchParams({
                value: value,
                variant: variantId,
            });

            fetch(
                globalObject.url + "ajax/ecommerce.php?action=updateShipping",
                {
                    method: "POST",
                    body: data,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            )
                .then((response) => response.json())
                .then((success) => {
                    updateCart();
                    if (success) {
                        if (shippingOption.classList.contains("pickup")) {
                            shippingOption
                                .closest(".cartShippingOptions")
                                .querySelector(
                                    ".locationChoice"
                                ).style.display = "block";
                        } else {
                            shippingOption
                                .closest(".cartShippingOptions")
                                .querySelector(
                                    ".locationChoice"
                                ).style.display = "none";
                        }
                    } else {
                        // Zip code validation failed
                        shoppingCart.querySelector(".cartZipError").innerHTML =
                            "We are unable to deliver to the provided postal code.";
                        shoppingCart.querySelector(
                            ".cartZipError"
                        ).style.display = "block";

                        // Reset shipping option
                        shoppingCart.querySelector(
                            ".shippingOption.pickup input"
                        ).checked = true;
                        shoppingCart
                            .querySelector(".shippingOption.pickup input")
                            .dispatchEvent(new Event("change"));
                    }
                })
                .catch((error) => console.error("Error:", error));
        }
    });
}

// Not sure if this is needed (cant find any usage)
function handleQuantityButtonsOnMobile() {
    const thisInput = document.querySelector("select.productQuantity");
    const thisDisplay = document.querySelector(
        "div.productQuantity .displayQuantity"
    );
    if (!thisInput || !thisDisplay) return;

    document.body.addEventListener("click", (e) => {
        if (e.target.matches("div.productQuantity.counter button")) {
            const button = e.target;
            const thisFunction = button.className;
            const thisQty = parseInt(thisInput.value);
            const maxQty = parseInt(
                thisInput.querySelector("option:last-child").value
            );

            if (!isNaN(thisQty)) {
                let newQty;

                if (thisFunction === "increaseQuantity" && thisQty < maxQty) {
                    newQty = thisQty + 1;
                } else if (thisFunction === "decreaseQuantity" && thisQty > 1) {
                    newQty = thisQty - 1;
                }

                if (newQty !== undefined) {
                    thisInput.value = newQty;
                    thisDisplay.textContent = newQty;

                    const increaseBtn = document.querySelector(
                        "button.increaseQuantity"
                    );
                    const decreaseBtn = document.querySelector(
                        "button.decreaseQuantity"
                    );

                    increaseBtn.classList.toggle("disabled", newQty === maxQty);
                    decreaseBtn.classList.toggle("disabled", newQty === 1);
                }
            }
        }
    });

    const currQty = parseInt(thisInput.value);
    if (currQty === 1) {
        // Disable the "decrease" button by adding the "disabled" class
        let decreaseBtn = document.querySelector(".decreaseQuantity");
        if (decreaseBtn) {
            decreaseBtn.classList.add("disabled");
        }
    }
}

// TODO: Add css for transition
function hideClosestAlertBanner(target) {
    const alertBanner = target.closest(".alertBanner");
    if (alertBanner) {
        alertBanner.style.display = "none";
    }
}

async function handleChangeCartZipCode(zipCode) {
    updateUserLocation(zipCode);
    const data = new URLSearchParams({ cartZip: zipCode });

    try {
        const response = await fetch(
            globalObject.url + "ajax/ecommerce.php?action=setCartZip",
            {
                method: "POST",
                body: data,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }
        );

        const responseText = await response.text();
        updateCart();

        if (responseText === "false") {
            return {
                success: false,
                message:
                    "We are unable to deliver to the provided postal code.",
            };
        }

        return {
            success: true,
        };
    } catch (error) {
        console.error("Error:", error);
        return {
            success: false,
            message: "We are unable to deliver to the provided postal code.",
        };
    }
}

function handleShippinFormErrors(errors, shippingForm) {
    for (let i = 0; i < errors.length; i++) {
        const value = errors[i];
        if (typeof value === "object" && value !== null) {
            // Object values
            if (value.deliveryMethod) {
                shippingForm.insertAdjacentHTML(
                    "beforebegin",
                    getDeliveryMethodMessage(value.deliveryMethod)
                );
                shippingForm
                    .querySelector(".deliveryMethodError")
                    .scrollIntoView();
                updateCart();
                // Return to prevent more errors from showing
                return false;
            }
        } else {
            // String values
            switch (value) {
                case "noLocation":
                    shippingForm
                        .querySelector(".pickUpStore .changeStore")
                        .classList.add("checkoutError");
                    break;
                case "deliveryRange":
                    shippingForm.insertAdjacentHTML(
                        "afterbegin",
                        getDeliveryRangeMessage()
                    );
                    shippingForm
                        .querySelector(".deliveryRangeError")
                        .scrollIntoView();
                    updateCart();
                    break;
                case "deliveryRangeQuote":
                    shippingForm.insertAdjacentHTML(
                        "afterbegin",
                        getDeliveryRangeMessage("quote")
                    );
                    shippingForm
                        .querySelector(".deliveryRangeError")
                        .scrollIntoView();
                    updateCart();
                    break;
                case "couponInvalid":
                    //Submit form again without invalid coupon
                    shippingForm.requestSubmit();
                    document
                        .querySelector("#billingForm")
                        .insertAdjacentHTML(
                            "beforebegin",
                            '<div class="alertBanner warning">One or more coupons are no longer valid and they have been removed from your cart. Please continue.</div>'
                        );
                    //Update totals to remove coupons
                    updateTotals();
                    break;
                case "accountExists":
                    document.querySelector(
                        ".createAccountContainer"
                    ).style.display = "none";
                    document.querySelector("#password").value = "";
                    document.querySelector("#createAccount").checked = false;
                    //Try again without submitting a password to create an account.
                    shippingForm.requestSubmit();
                    document
                        .querySelector("#billingForm")
                        .insertAdjacentHTML(
                            "beforebegin",
                            "<div class=\"alertBanner warning\">An account with this email address already exists. But don't worry, you'll still be able to see your order in your account once you complete the purchase.</div>"
                        );
                    break;
                case "invalidPassword":
                    shippingForm
                        .querySelector(".section-Contact h4")
                        .insertAdjacentHTML(
                            "afterend",
                            '<div class="alertBanner warning checkoutError">Passwords should be at least 8 characters. Please try a different password and try again.</div>'
                        );
                    shippingForm.querySelector("#password").value = "";
                    break;
                case "firstName":
                case "lastName":
                    let value = "firstName";
                    let name = value
                        .replace(/([a-z])([A-Z])/g, "$1 $2")
                        .toLowerCase();
                    shippingForm
                        .querySelector(`input#${name.split(" ")[0]}`)
                        .insertAdjacentHTML(
                            "afterend",
                            `<div class="alertBanner alert checkoutError">
                                Please enter your ${name} 
                            </div>`
                        );
                    break;
                case "state":
                    shippingForm
                        .querySelector("select#state")
                        .insertAdjacentHTML(
                            "afterend",
                            '<div class="alertBanner alert checkoutError">Please select your state</div>'
                        );
                    break;
                case "distanceError":
                    shippingForm
                        .querySelector(".shipFields")
                        .insertAdjacentHTML(
                            "afterend",
                            '<div class="alertBanner alert checkoutError">Please enter a valid address</div>'
                        );
                    break;
                case "invalidRecipientAddress":
                    shippingForm
                        .querySelector(".shipFields")
                        .insertAdjacentHTML(
                            "afterend",
                            '<div class="alertBanner alert checkoutError">Could not verify shipping address. Please enter a new shipping address and try again.</div>'
                        );
                    break;
                case "zip":
                    shippingForm
                        .querySelector(".shipFields")
                        .insertAdjacentHTML(
                            "afterend",
                            '<div class="alertBanner alert checkoutError">Zipcode is outside of our service area.</div>'
                        );
                    break;
                case "shippingError":
                    shippingForm
                        .querySelector(".shipFields")
                        .insertAdjacentHTML(
                            "afterend",
                            '<div class="alertBanner alert checkoutError">We cannot ship to this address.</div>'
                        );
                    break;
                case "stateZipMismatch":
                    shippingForm
                        .querySelector(".shipFields")
                        .insertAdjacentHTML(
                            "afterend",
                            '<div class="alertBanner alert checkoutError">Please verify your state and zipcode.</div>'
                        );
                    break;
                default:
                    shippingForm
                        .querySelector(`input#${value}`)
                        .insertAdjacentHTML(
                            "afterend",
                            `<div class="alertBanner alert checkoutError">Please verify your ${value}</div>`
                        );
                    break;
            }
        }
    }
}

function handleBillingFormErrors(errors, billingForm) {
    let message =
        "There was an error processing the payment.  Please verify your information or try another payment method."; //Default message
    let severity = "alert";
    let isCCError = false;

    for (let error of errors ?? []) {
        if (typeof error === "object" && error.dataDeliveryMethod) {
            document
                .querySelector("#shippingForm")
                .insertAdjacentHTML(
                    "afterbegin",
                    getDeliveryMethodMessage(error.deliveryMethod)
                );
            document
                .querySelector("#shippingForm .deliveryMethodError")
                .scrollIntoView();
            updateCart();
            goToPage("shipping", 1);
            break; // Return to prevent more errors from showing
        } else {
            switch (error) {
                case "deliveryRange":
                    document
                        .querySelector("#shippingForm")
                        .insertAdjacentHTML(
                            "afterbegin",
                            getDeliveryRangeMessage()
                        );
                    document
                        .querySelector("#shippingForm .deliveryRangeError")
                        .scrollIntoView();
                    updateCart();
                    goToPage("shipping", 1);
                    break;
                case "deliveryRangeQuote":
                    document
                        .querySelector("#shippingForm")
                        .insertAdjacentHTML(
                            "afterbegin",
                            getDeliveryRangeMessage("quote")
                        );
                    document
                        .querySelector("#shippingForm .deliveryRangeError")
                        .scrollIntoView();
                    updateCart();
                    goToPage("shipping", 1);
                    break;

                case "charge":
                    // console.log('There was an error in charging the credit card.');
                    isCCError = true;
                    break;

                case "cartValidation":
                    // console.log('There was an error in validating the cart.');
                    break;

                case "address":
                    message =
                    "We were unable to verify your address. Please check the address and try again.";
                    break;

                case "state":
                    // console.log('There was an error validating the state.');
                    break;

                case "zip":
                    // console.log('There was an error validating the zip code.');
                    break;

                case "totals":
                    // console.log('There was an error with cart totals calculation.');
                    break;

                case "tax":
                    message =
                        "We were unable to process the request. Please try again later.";
                    break;

                case "shipping":
                    message =
                        "We were unable to process the request. Please try again later.";
                    break;

                case "delivery":
                    message =
                        "We were unable to process the request. Please try again later.";
                    break;

                case "totalsValidation":
                    message =
                        "The prices in your cart have been updated. Please look at the order summary to verify the total, then try placing the order again.";
                    severity = "warning";
                    // console.log('There was an error validating cart totals.');
                    break;

                case "minimumPurchase":
                    message =
                        "The payment method you selected requires your order total to be greater than its minimum purchase. Please select another payment method and try again.";
                    break;

                case "shippingStepNotCompleted":
                    // console.log('Cart step not yet completed: shipping.');
                    break;

                case "cardDeclined":
                case "insufficientFunds":
                    message =
                        "The card was declined. Please verify the card information is correct or contact the card issuer, then try again.";
                    isCCError = true;
                    break;

                case "invalidAccountNumber":
                    message =
                        "The card number is invalid. Please check the number and try again.";
                    isCCError = true;
                    break;

                case "invalidExpiration":
                case "cardExpired":
                    message =
                        "The expiration date is invalid. Please check the date and try again.";
                    isCCError = true;
                    break;

                case "fraudAVSDeclined":
                    message =
                        "The billing address could not be verified. Please check that the information is correct and matches the address associated with the card.";
                    break;

                case "paypalTotal":
                case "paypalCharge":
                    message =
                        "The order could not be completed through PayPal.";
                    isCCError = true;
                    break;

                case "clientTimeout":
                case "processorTimeout":
                case "bankTimeout":
                    message =
                        "The card could not be processed because the request timed out. Please try again.";
                    isCCError = true;
                    break;

                case "processorNotAvailable":
                case "bankNotAvailable":
                    message =
                        "The card could not be processed because the issuer could not be reached. Please try again.";
                    isCCError = true;
                    break;

                case "invalidTender":
                    message =
                        "The tender associated with the card is not supported.";
                    isCCError = true;
                    break;

                case "invalidHostMapping":
                case "cardNotAccepted":
                    message =
                        "The card type is not accepted at this time. Please try another card.";
                    isCCError = true;
                    break;

                case "transactionLimit":
                    message =
                        "The card was declined because the transaction limit was exceeded.";
                    isCCError = true;
                    break;

                case "systemBusy":
                    message =
                        "The card could not be processed because the system is temporarily unavailable, please try again.";
                    isCCError = true;
                    break;

                case "processingError":
                    message =
                        "The card could not be processed because an error ocurred. Please try again.";
                    isCCError = true;
                    break;

                default:
                    // console.log(value);
                    break;
            }
        }
    }

    // Show error
    const alertBanner = document.createElement("div");
    alertBanner.classList.add("alertBanner", severity, "checkoutError");
    alertBanner.textContent = message;

    const submitButton = document.querySelector(
        "#billingForm input[type='submit']"
    );
    submitButton.parentNode.insertBefore(alertBanner, submitButton.nextSibling);

    // Update cart
    updateCart();

    // If there was an issue with the credit card, show "On Credit Card Error" payment method if available
    if (isCCError) {
        const paymentMethods = document.querySelectorAll(
            "ul.paymentMethods li.paymentMethod"
        );
        paymentMethods.forEach((method) => {
            if (method.classList.contains("displayType-on_credit_card_error")) {
                method.classList.remove("d-none");
            }
        });
    }
}

function handleShippingFormSubmit() {
    const shippingForm = document.querySelector("#shippingForm");
    if (!shippingForm) return;


    shippingForm.addEventListener("submit", (e) => {
        e.preventDefault();
        let hasErrors = false;

        // Remove any existing error messages
        shippingForm
            .querySelectorAll(".checkoutError")
            .forEach((el) => el.remove());

        // Check if all required fields are filled out
        const requiredFields = [
            "first",
            "last",
            "phone",
            "address",
            "city",
            "state",
            "zip",
        ];
        const shippingFields = shippingForm.querySelectorAll("input, select");

        shippingFields.forEach((field) => {
            if (!requiredFields.includes(field.name)) return;

            if (field.value === "") {
                field
                    .closest(".input")
                    .insertAdjacentHTML(
                        "beforeend",
                        '<div class="alertBanner alert checkoutError">Please fill out required field.</div>'
                    );
                hasErrors = true;
            } else if (field.name === "phone") {
                let phoneVal = field.value.replace(/[^\d]/g, ""); // Strip masking characters
                if (phoneVal.length !== 10) {
                    field
                        .closest(".input")
                        .insertAdjacentHTML(
                            "beforeend",
                            '<div class="alertBanner alert checkoutError">Please enter a valid phone number.</div>'
                        );
                    hasErrors = true;
                }
            }
        });

        // If checkout errors exist, don't continue
        if (hasErrors) return;

        showLoadingOverlay();

        // Pre-validate address with USPS before submitting
        const addressFields = {
            address: shippingForm.querySelector("[name='address']")?.value?.trim() ?? "",
            address2: shippingForm.querySelector("[name='address2']")?.value?.trim() ?? "",
            city: shippingForm.querySelector("[name='city']")?.value?.trim() ?? "",
            state: shippingForm.querySelector("[name='state']")?.value?.trim() ?? "",
            zip: shippingForm.querySelector("[name='zip']")?.value?.trim() ?? "",
        };

        fetch(globalObject.url + "ajax/ecommerce.php?action=validateAddress", {
            method: "POST",
            body: new URLSearchParams(addressFields),
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.valid && (result.hasCorrections || result.needsMoreInfo)) {
                    hideLoadingOverlay();
                    showAddressSuggestionModal(result, shippingForm);
                } else {
                    submitShippingForm(shippingForm);
                }
            })
            .catch((error) => {
                // If validation endpoint fails, proceed with checkout anyway
                console.error("USPS address pre-validation failed:", error);
                submitShippingForm(shippingForm);
            });
    });
}

/**
 * Displays a modal allowing the user to choose between their original
 * address and the USPS-corrected suggestion.
 */
function showAddressSuggestionModal(result, shippingForm) {
    const input = result.input;
    const corrected = result.corrected;

    const formatAddress = (addr) =>
        `${addr.address}${addr.address2 ? ", " + addr.address2 : ""}<br>${addr.city}, ${addr.state} ${addr.zip}`;

    const correctionNotice = result.corrections?.length
        ? `<p class="addressSuggestionModal__notice">${result.corrections[0]}</p>`
        : "";

    const showSuggested = result.hasCorrections;

    const needsMoreInfo = result.needsMoreInfo;

    const modalHtml = `
        <div class="modal addressSuggestionModal">
            <h3 class="addressSuggestionModal__title">Verify your address</h3>
            <p class="addressSuggestionModal__subtitle">${showSuggested
                ? "We found a suggested address. Please choose which to use:"
                : "We found an issue with your address:"
            }</p>
            ${correctionNotice}

            ${showSuggested ? `
            <div class="addressOption addressOption--selected suggestedAddress" tabindex="0" role="button">
                <span class="addressOption__radio"></span>
                <div class="addressOption__content">
                    <strong class="addressOption__label">Suggested address</strong>
                    <span class="addressOption__address">${formatAddress(corrected)}</span>
                </div>
            </div>
            ` : ""}

            <div class="addressOption ${showSuggested ? "" : "addressOption--selected"} originalAddress" tabindex="0" role="button">
                <span class="addressOption__radio"></span>
                <div class="addressOption__content">
                    <strong class="addressOption__label">Original address</strong>
                    <span class="addressOption__address">${formatAddress(input)}</span>
                </div>
            </div>

            ${needsMoreInfo ? `
            <button class="addressSuggestionCorrect button" type="button">
                Make corrections
            </button>
            ` : ""}

            <button class="addressSuggestionSubmit button" type="button">
                ${needsMoreInfo
                    ? (showSuggested ? "Use selected address anyway" : "Continue with this address")
                    : (showSuggested ? "Use selected address" : "Continue with this address")
                }
            </button>
        </div>
    `;

    displayModal(modalHtml);

    // Address option selection
    const options = document.querySelectorAll(".addressSuggestionModal .addressOption");
    let selectedAddress = showSuggested ? corrected : input;

    options.forEach((option) => {
        option.addEventListener("click", () => {
            options.forEach((o) => o.classList.remove("addressOption--selected"));
            option.classList.add("addressOption--selected");
            selectedAddress = option.classList.contains("suggestedAddress") ? corrected : input;
        });
    });

    // Make corrections button — apply selected address fields, then close modal
    const correctBtn = document.querySelector(".addressSuggestionCorrect");
    if (correctBtn) {
        correctBtn.addEventListener("click", () => {
            const setField = (name, value) => {
                const field = shippingForm.querySelector(`[name='${name}']`);
                if (field) field.value = value;
            };
            setField("address", selectedAddress.address);
            setField("address2", selectedAddress.address2);
            setField("city", selectedAddress.city);
            setField("state", selectedAddress.state);
            setField("zip", selectedAddress.zip);
            removeModal();
        });
    }

    // Submit button
    document.querySelector(".addressSuggestionSubmit").addEventListener("click", () => {
        // Update form fields with selected address
        const setField = (name, value) => {
            const field = shippingForm.querySelector(`[name='${name}']`);
            if (field) field.value = value;
        };
        setField("address", selectedAddress.address);
        setField("address2", selectedAddress.address2);
        setField("city", selectedAddress.city);
        setField("state", selectedAddress.state);
        setField("zip", selectedAddress.zip);

        removeModal();
        showLoadingOverlay();
        submitShippingForm(shippingForm);
    });
}

/**
 * Submits the shipping checkout form to the backend.
 */
function submitShippingForm(shippingForm) {
    const data = new URLSearchParams(new FormData(shippingForm));

    fetch(globalObject.url + "ajax/ecommerce.php?action=checkoutShipping", {
        method: "POST",
        body: data,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    })
        .then((response) => response.json())
        .then((response) => {
            if (response == 1) {
                GoogleAnalytics.onAddShippingInfo();
                goToPage("billing", 1);
            } else if (response == "noZip") {
                const zipField = shippingForm.querySelector("input#zip");
                zipField.insertAdjacentHTML(
                    "afterend",
                    '<div class="alertBanner alert checkoutError">Please enter your zip code</div>'
                );
            } else {
                const errors = response;
                if (errors.length === 0) {
                    shippingForm
                        .querySelector("input[type='submit']")
                        .insertAdjacentHTML(
                            "afterend",
                            '<div class="alertBanner alert checkoutError">The request could not be completed. Please verify your information and try again.</div>'
                        );
                } else {
                    // Display errors, if any
                    handleShippinFormErrors(errors, shippingForm);

                    if (window.innerWidth <= 768) {
                        let firstErrorElement =
                            document.querySelector(".checkoutError");
                        if (firstErrorElement) {
                            document.documentElement.scrollTop =
                                firstErrorElement.offsetTop - 100;
                        }
                    }
                }
            }
        })
        .catch((error) => console.error("Error:", error))
        .finally(() => hideLoadingOverlay());
}

function handleBillingFormSubmit() {
  const billingForm = document.querySelector("#billingForm");
  if (!billingForm) return;

  billingForm.addEventListener("submit", (e) => {
    e.preventDefault();

    // Remove any existing error messages
    billingForm.querySelectorAll(".checkoutError").forEach((el) => el.remove());

    const requiredFields = [
      "billFirst",
      "billLast",
      "billPhone",
      "billAddress",
      "billCity",
      "billState",
      "billZip",
    ];
    const differentAddress = document.querySelector(
      "input[name=differentAddress]"
    );
    const billingInfo = billingForm.querySelector(".billingInfo");
    const hasBillingAddress = billingInfo &&
      (billingInfo.style.display !== "none" || differentAddress?.checked);

    // Check billing informations has been filled out
    if (hasBillingAddress) {
      const billingFields = billingForm.querySelectorAll("input, select");

      billingFields.forEach((field) => {
        if (!requiredFields.includes(field.name)) return;

        if (field.value === "") {
          field
            .closest(".input")
            .insertAdjacentHTML(
              "beforeend",
              '<div class="alertBanner alert checkoutError">Please fill out required field.</div>'
            );
        } else if (field.name === "billPhone") {
          let phoneVal = field.value.replace(/[^\d]/g, ""); // Strip masking characters
          if (phoneVal.length !== 10) {
            field
              .closest(".input")
              .insertAdjacentHTML(
                "beforeend",
                '<div class="alertBanner alert checkoutError">Please enter a valid phone number.</div>'
              );
          }
        }
      });
    }

    // Select payment method
    const paymentMethod = document.querySelector("li.paymentMethod.selected");
    const cardNumber = paymentMethod?.querySelector("input.cardNumber");

    // Check car length/luhn and cvv lengths first
    if (cardNumber) {
      let card = cardFromNumber(cardNumber.value);
      let cardInputStripped = cardNumber.value.replace(/\D/g, "");
      let securityCodeInput = paymentMethod.querySelector("input.securityCode");
      let expirationMonth = paymentMethod.querySelector(
        "select.expirationMonth"
      );
      let expirationYear = paymentMethod.querySelector("select.expirationYear");
      let today = new Date();

      let cardInfo = null;
      cards.forEach((c) => {
        if (card == c.type) {
          cardInfo = c;
          return;
        }
      });

      if (
        cardInputStripped.length < 12 ||
        !cardInfo.length.includes(cardInputStripped.length) ||
        !luhnCheck(cardInputStripped)
      ) {
        // Handle invalid card number
        cardNumber
          .closest(".input")
          .insertAdjacentHTML(
            "beforeend",
            '<div class="alertBanner alert checkoutError">Please enter a valid card number.</div>'
          );
      }

      if (securityCodeInput) {
        const sanitizedInputLength = securityCodeInput.value.replace(
          /\D/g,
          ""
        ).length;
        if (
          (cardInfo && !cardInfo.cvcLength.includes(sanitizedInputLength)) ||
          sanitizedInputLength === 0
        ) {
          // Handle invalid security code
          securityCodeInput
            .closest(".input")
            .insertAdjacentHTML(
              "beforeend",
              '<div class="alertBanner alert checkoutError">Please verify your Security Code / CVV.</div>'
            );
        }
      }

      if (
        expirationYear &&
        (expirationYear.value < (today.getFullYear() % 100).toString() ||
          (expirationYear.value === (today.getFullYear() % 100).toString() &&
            expirationMonth.value < today.getMonth() + 1))
      ) {
        // Handle invalid expiration date
        expirationYear
          .closest(".input")
          .insertAdjacentHTML(
            "beforeend",
            '<div class="alertBanner alert checkoutError" style="width: 89%">Please verify your expiration date.</div>'
          );
      }
    }

    // Verify payment plan is selected if required
    const paymentPlans = paymentMethod?.querySelector(".paymentPlans");
    if (paymentPlans) {
      let selected = paymentPlans.querySelector("li.selected");
      if (!selected) {
        paymentPlans.insertAdjacentHTML(
          "beforebegin",
          '<div class="alertBanner alert checkoutError">Please select a payment plan.</div>'
        );
      }
    }

    // If checkout errors exist, don't continue
    if (document.querySelector(".checkoutError")) return;

    const data = new URLSearchParams(new FormData(billingForm));
    showLoadingOverlay();
    fetch(globalObject.url + "ajax/ecommerce.php?action=checkoutBilling", {
      method: "POST",
      body: data,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((response) => response.text())
      .then((response) => {
        if (response == "1") {
          window.location.href = "thank-you";
        } else {
          let errors;

          try {
            errors = JSON.parse(response);
          } catch (err) {
            console.log(response);
            console.log(err);
          } finally {
            if (errors === undefined) errors = [];
          }

          if (errors?.redirect !== undefined) {
            window.location.href = errors.redirect;
          } else {
            // There was an error
            handleBillingFormErrors(errors, billingForm);
          }
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => hideLoadingOverlay());
  });
}

function removeSelectedAddressHighlight(selector) {
    document.querySelectorAll(selector).forEach((el) => {
        el.classList.remove("selectedAddress", "selectedHighlight");
    });
}

function handleSelectSavedAddress() {
    const shippingAddresses = document.querySelectorAll(
        ".shipOptions .savedAddress"
    );
    const billingAddresses = document.querySelectorAll(
        ".billingInfo .savedAddress"
    );
    if (shippingAddresses.length > 0) {
        shippingAddresses.forEach((el) => {
            el.addEventListener("click", (e) => {
                // Remove selected class from all saved addresses
                removeSelectedAddressHighlight(".shipOptions .savedAddress");

                // Add selected class to clicked address
                el.classList.add("selectedAddress", "selectedHighlight");

                // Populate shipping fields with saved address data
                const shippingFields = document.querySelector(".shipFields");
                if (shippingFields) {
                    shippingFields.querySelector("input#first").value =
                        el.dataset.first;
                    shippingFields.querySelector("input#last").value =
                        el.dataset.last;
                    shippingFields.querySelector("input#phone").value =
                        el.dataset.phone;
                    shippingFields.querySelector("input#address").value =
                        el.dataset.address;
                    shippingFields.querySelector("input#address2").value =
                        el.dataset.address2;
                    shippingFields.querySelector("input#city").value =
                        el.dataset.city;
                    shippingFields.querySelector("select#state").value =
                        el.dataset.state;
                    shippingFields.querySelector("input#zip").value =
                        el.dataset.zip;
                }
            });
        });
    }

    if (billingAddresses.length > 0) {
        billingAddresses.forEach((el) => {
            el.addEventListener("click", (e) => {
                // Remove selected class from all saved addresses
                removeSelectedAddressHighlight(".billingInfo .savedAddress");

                // Add selected class to clicked address
                el.classList.add("selectedAddress", "selectedHighlight");

                // Populate billing fields with saved address data
                const billingFields = document.querySelector(".billFields");
                if (billingFields) {
                    billingFields.querySelector("input#billFirst").value =
                        el.dataset.first;
                    billingFields.querySelector("input#billLast").value =
                        el.dataset.last;
                    billingFields.querySelector("input#billPhone").value =
                        el.dataset.phone;
                    billingFields.querySelector("input#billAddress").value =
                        el.dataset.address;
                    billingFields.querySelector("input#billAddress2").value =
                        el.dataset.address2;
                    billingFields.querySelector("input#billCity").value =
                        el.dataset.city;
                    billingFields.querySelector("select#billState").value =
                        el.dataset.state;
                    billingFields.querySelector("input#billZip").value =
                        el.dataset.zip;
                }
            });
        });
    }
}

function handleNewAddressClick(parent, fieldSelector) {
    const addressButton = document.querySelector(`${parent} .newAddress`);
    if (addressButton) {
        addressButton.addEventListener("click", (e) => {
            removeSelectedAddressHighlight(`${parent} .savedAddress`);
            const fields = document.querySelector(fieldSelector);
            if (fields) {
                fields.querySelectorAll("input").forEach((el) => {
                    el.value = "";
                });
                fields.querySelectorAll("select").forEach((el) => {
                    el.value = "";
                });

                fields.style.display = "block";
            }
        });
    }
}

function handleCardNumberInput() {
    const cardInput = document.querySelector("input.cardNumber");
    if (!cardInput) return;

    const imageCards = [
        "amex",
        "dinersclub",
        "discover",
        "jcb",
        "laser",
        "maestro",
        "mastercard",
        "visa",
    ];
    const formatCards = ["discover", "jcb", "maestro", "mastercard", "visa"];

    cardInput.addEventListener("keyup", (e) => {
        let number = cardInput.value;
        let card = cardFromNumber(number);

        if (![8, 46].includes(e.keyCode)) {
            let ccIconContainer = cardInput
                .closest(".input")
                .querySelector(".ccIconContainer");
            let icon = ccIconContainer?.querySelector(".ccIcon") ?? null;

            // Display icon images if exist
            if (imageCards.includes(card) && number.length >= 2) {
                if (!icon) {
                    let img = document.createElement("img");
                    img.classList.add("ccIcon");
                    img.src = `https://cdn.knorrweb.com/sites/_shared/cc-icons/${card}.png`;
                    img.alt = `${card}-icon`;
                    ccIconContainer && ccIconContainer.appendChild(img);
                }
            } else {
                icon?.remove();
            }

            // Format card number if possible
            if (formatCards.includes(card) && number.length >= 4) {
                if ([4, 9, 14].includes(number.length)) {
                    cardInput.value = number + " ";
                } else if (
                    number >= 13 &&
                    number <= 19 &&
                    /\d{13,19}$/.test(number)
                ) {
                    cardInput.value = `${number.slice(0, 4)} ${number.slice(
                        4,
                        8
                    )} ${number.slice(8, 12)} ${number.slice(12, 16)}`;
                }
            } else if (card === "amex" || card === "dinersclub") {
                if (number.length === 4 || number.length === 11) {
                    cardInput.value = number + " ";
                } else if (
                    number >= 14 &&
                    number <= 15 &&
                    /\d{14,15}$/.test(number)
                ) {
                    cardInput.value = `${number.slice(0, 4)} ${number.slice(
                        4,
                        10
                    )} ${number.slice(10)}`;
                }
            } else {
                icon?.remove();
            }
        }
    });
}

function handleCartCheckoutButton() {
    document.querySelectorAll(".cartCheckoutButton").forEach((btn) => {
        btn.addEventListener("click", (e) => {
            let href = e.target.getAttribute("href");
            e.preventDefault();
            // Hide any existing zip code error messages
            document.querySelectorAll(".cartZipError").forEach((el) => {
                el.style.display = "none";
            });

            // Check if pickup or quote option
            let isPickup = false;
            let isRequestQuote = false;
            document.querySelectorAll(".shippingOption").forEach((option) => {
                let checked = option.querySelector("input").checked;
                if (checked && option.classList.contains("pickup")) {
                    isPickup = true;
                } else if (checked && option.classList.contains("quote")) {
                    isRequestQuote = true;
                }
            });

            // change delivery method of all items in cart to request quote if one of the items is request quote
            const changeDeliveryToRequestQuote = new Promise((resolve, reject) => {
                if (isRequestQuote) {
                    fetch(globalObject.url + "ajax/ecommerce.php?action=changeDeliveryToRequestQuote", {
                        method: "POST",
                    })
                    .then((response) => response.text())
                    .then(() => {
                        console.info("Delivery method of all items in cart changed to request quote.");
                        resolve();
                    })
                    .catch((error) => {
                        console.error("Error:", error);
                        reject(error);
                    });
                } else {
                    resolve(); // Resolve the Promise immediately if isRequestQuote is false
                }
            });

            changeDeliveryToRequestQuote.then(() => {

                if (isPickup) {
                    if (href) {
                        window.location.href = href;
                    } else {
                        window.location.href = "checkout";
                    }
                    return;
                }

                document.querySelectorAll(".cartZipForm").forEach(async (form) => {
                    const zipInput = form.querySelector("input").value;
                    let response;
                    if (form.style.display !== "none" && zipInput !== "") {
                        try {
                            response = await handleChangeCartZipCode(zipInput);
                            if (!response.success) {
                                // Find the Alpine.js div by its ID
                                const cartZipError =
                                    document.querySelector(".cartZipError");
                                if (cartZipError) {
                                    cartZipError.innerHTML = response.message;
                                    cartZipError.style.display = "block";
                                }
                            } else {
                                if (href) {
                                    window.location.href = href;
                                } else {
                                    window.location.href = "checkout";
                                }
                            }
                        } catch (error) {
                            console.error("Error:", error);
                        }
                    } else {
                        // Check if cart zip is valid
                        fetch(
                            globalObject.url +
                                "ajax/ecommerce.php?action=getCartZip"
                        )
                        .then((response) => response.text())
                        .then((zipCode) => {
                            if (zipCode) {
                                if(href) {
                                    window.location.href = href;
                                } else {
                                    window.location.href = "checkout";
                                }
                            } else {
                                // Display error message
                                const cartZipError =
                                    document.querySelector(".cartZipError");
                                if (cartZipError) {
                                    cartZipError.innerHTML =
                                        "Please enter your zip code.";
                                    cartZipError.style.display = "block";
                                }
                            }
                        });
                    }
                });
            });
        });
    });
}

function checkForCouponParam() {
    const coupon = getUrlParameter("coupon");
    if (coupon) {
        document.querySelector(".applyCouponButton").click();
    }
}

function handleCreateAccountCheckbox() {
    const createAccountBtn = document.querySelector("#createAccount");
    if (createAccountBtn) {
        createAccountBtn.addEventListener("change", function () {
            if (this.checked) {
                document.querySelector(".passwordField").style.display =
                    "block";
            } else {
                document.querySelector(".passwordField").style.display = "none";
            }
        });
    }
}

function cartPageActions() {
    const cartPage = document.querySelector(".page-cart");
    if (!cartPage) return;

    handleExternalCartParams();
    handleShoppingCartEvents();
    handleApplyCoupon();
    handleRemoveCoupon();
    handleCartAddons();
    handleUpdateShippingOption();
    handleCartCheckoutButton();
    checkForCouponParam();
}

function checkoutPageActions() {
    const checkoutPage = document.querySelector(".checkout");
    if (!checkoutPage) return;

    handleCreateAccountCheckbox();
    handleApplyCoupon();
    handleRemoveCoupon();
    handleCheckoutFormEvents();
    handleShippingFormSubmit();
    handleSelectSavedAddress();
    handleNewAddressClick(".shipOptions", ".shipFields");
    handleNewAddressClick(".billingInfo", ".billFields");
    handleCardNumberInput();
    handleBillingFormSubmit();
    checkForCouponParam();

    //Update shipping layout during checkout
    if (
        window.location.pathname.indexOf("checkout") !== -1 &&
        window.location.pathname.indexOf("payment") === -1
    ) {
        //Shipping page
        updateShippingLayout("edit");
    } else if (
        window.location.pathname.indexOf("checkout") !== -1 &&
        window.location.pathname.indexOf("payment") !== -1
    ) {
        //Payment page
        updateShippingLayout("quick");
    }

    // Show/hide cvc tooltip on mobile
    if (window.innerWidth <= 768) {
        const cvcTooltip = document.querySelector(
            ".cardNum_securityCode .svg-icon"
        );
        if (cvcTooltip) {
            cvcTooltip.addEventListener("click", () => {
                document.getElementById("securityCodeToolTip").style.display =
                    "block";
            });
        }
    }

    document
        .querySelectorAll(
            ".checkout.thank-you .orderDetails .paymentMethod a.seeDetails"
        )
        .forEach((el) => {
            el.addEventListener("click", function (e) {
                e.preventDefault();
                el
                    .closest(".paymentMethod")
                    .querySelector(".details").style.display = "block";
            });
        });
    
        const shippingEditButton = document.getElementById("shippingEdit");
    if (shippingEditButton) {
        shippingEditButton.addEventListener("click", function () {
            goToPage("shipping", 1);
        });
    }
    // document
    //     .getElementById("shippingEdit")
    //     .addEventListener("click", function () {
    //         goToPage("shipping", 1);
    //     });
    window.addEventListener("popstate", function (event) {
        const state = event.state;

        if (state) {
            if (state.step == "payment") {
                goToPage("billing", 0);
            }
        } else {
            goToPage("shipping", 0);
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    const addToCart = new AddToCart();
    addToCart.init();
    const productPageQuantity = new ProductPageQuantity();
    productPageQuantity.init();
    const paymentMethods = new PaymentMethods();
    paymentMethods.init();

    cartPageActions();
    checkoutPageActions();
    handleQuantityButtonsOnMobile();
});

pushToDataLayer = function (step, variant) {
    if (step == "addToCart" || step == "removeFromCart") {
        fetch(
            globalObject.url + "ajax/ecommerce.php?action=generateDataLayer",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: "step=" + step + "&variant=" + variant,
            }
        )
            .then((response) => response.json())
            .then((data) => {
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push(data);
            })
            .catch((error) => console.error("Error:", error));
    } else if (step == "payment") {
        // FIX ME
        let dataLayer = window.dataLayer;
        if (dataLayer) {
            let data = dataLayer.filter(function (i) {
                return i.event == "checkout";
            })[0];
            data.ecommerce.checkout.actionField.step = "3";
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push(data);
        }
    }
};

//CREDIT CARD PATTERNS
cards = [
    {
        type: "amex",
        pattern: /^3[47]/,
        format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
        length: [15],
        cvcLength: [4],
        luhn: true,
    },
    {
        type: "dankort",
        pattern: /^5019/,
        format: /(\d{1,4})/g,
        length: [16],
        cvcLength: [3],
        luhn: true,
    },
    {
        type: "hipercard",
        pattern: /^(384100|384140|384160|606282|637095|637568|60(?!11))/,
        format: /(\d{1,4})/g,
        length: [14, 15, 16, 17, 18, 19],
        cvcLength: [3],
        luhn: true,
    },
    {
        type: "dinersclub",
        pattern: /^(36|38|30[0-5])/,
        format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
        length: [14],
        cvcLength: [3],
        luhn: true,
    },
    {
        type: "discover",
        pattern: /^(6011|65|64[4-9]|622)/,
        format: /(\d{1,4})/g,
        length: [16],
        cvcLength: [3],
        luhn: true,
    },
    {
        type: "jcb",
        pattern: /^35/,
        format: /(\d{1,4})/g,
        length: [16],
        cvcLength: [3],
        luhn: true,
    },
    {
        // Looks to no longer be a valid cc company but leaving just in case
        type: "laser",
        pattern: /^(6706|6771|6709)/,
        format: /(\d{1,4})/g,
        length: [16, 17, 18, 19],
        cvcLength: [3],
        luhn: true,
    },
    {
        type: "maestro",
        pattern: /^(5018|5020|5038|6304|6703|6708|6759|676[1-3])/,
        format: /(\d{1,4})/g,
        length: [12, 13, 14, 15, 16, 17, 18, 19],
        cvcLength: [3],
        luhn: true,
    },
    {
        type: "mastercard",
        pattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
        format: /(\d{1,4})/g,
        length: [16],
        cvcLength: [3],
        luhn: true,
    },
    {
        type: "unionpay",
        pattern: /^62/,
        format: /(\d{1,4})/g,
        length: [16, 17, 18, 19],
        cvcLength: [3],
        luhn: false,
    },
    {
        type: "visaelectron",
        pattern: /^4(026|17500|405|508|844|91[37])/,
        format: /(\d{1,4})/g,
        length: [16],
        cvcLength: [3],
        luhn: true,
    },
    {
        type: "elo",
        pattern:
            /^(4011(78|79)|43(1274|8935)|45(1416|7393|763(1|2))|50(4175|6699|67[0-7][0-9]|9000)|627780|63(6297|6368)|650(03([^4])|04([0-9])|05(0|1)|4(0[5-9]|3[0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8])|9([2-6][0-9]|7[0-8])|541|700|720|901)|651652|655000|655021)/,
        format: /(\d{1,4})/g,
        length: [16],
        cvcLength: [3],
        luhn: true,
    },
    {
        type: "visa",
        pattern: /^4/,
        format: /(\d{1,4})/g,
        length: [13, 16, 19],
        cvcLength: [3],
        luhn: true,
    },
];
